import { call, put, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from '../config/firebase'
import DelivereeAction from '../reducers/delivereeReducer'
import DelivereeReportAction from '../reducers/delivereeReportReducer'

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        const users = {}

        data.forEach(res => {
          users[res.key] = { ...res.val(), uid: res.key }
        })

        emit(users)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  })

  return listener
}

export function* fetchUsers() {
  const database = firebase.database()
  const usersConnectionRef = database.ref('/deliverees').orderByChild('created_at')
  const databaseEventChannel = yield call(observerEvent, usersConnectionRef) // listening databaseEvent
  try {
    while (true) {
      const users = yield take(databaseEventChannel) // take event data
      yield put(DelivereeAction.fetchDelivereesConnected(users))
    }
  } catch (error) {
    yield put(DelivereeAction.fetchDelivereesError(error))
  } finally {
    databaseEventChannel.close()
  }
}

export function* getDeliveree({ uid }) {
  const ref = firebase.database().ref(`deliverees/${uid}`)

  const snapshot = yield call([ref, ref.once], 'value')
  const deliveree = snapshot.val()

  if (deliveree) {
    yield put(DelivereeAction.setDeliveree({ ...deliveree, uid }))
  } else {
    yield put(DelivereeAction.setDelivereeLoading(false))
  }
}

export function* getDelivereeReport({ startAt, endAt }) {
  try {
    const delivereeRef = firebase.database().ref('deliverees').orderByChild('created_at').startAt(startAt).endAt(endAt)
    const snapshot = yield call([delivereeRef, delivereeRef.once], 'value')
    const deliverees = snapshot.val() && Object.values(snapshot.val())

    if (deliverees) {
      const payingDeliverees = deliverees.filter(deliveree => (deliveree.delivered_order_count || 0) > 0)

      const delivereeCount = deliverees.length
      const payingDelivereeCount = payingDeliverees.length

      yield put(DelivereeReportAction.setDelivereeReport({
        delivereeCount,
        payingDelivereeCount,
      }))
    } else {
      yield put(DelivereeReportAction.setDelivereeReportLoading(false))
    }
  } catch (error) {
    yield put(DelivereeReportAction.setDelivereeReportLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/delivereeSaga.js